import { DEFAULT_SORT_BY } from '@modules/common/constants';
import {
  getReportDataPointFromAggregatesResponse,
  sortReportDataPoints,
} from '@modules/common/utils';
import { ExecuteEQLResponse } from 'v2/core/repository/edge-server/types';

interface GetReportDataPointsOptions {
  data?: ExecuteEQLResponse;
  shouldRemoveFileUploadPrefix: boolean;
}

export const getReportDataPoints = ({
  data,
  shouldRemoveFileUploadPrefix,
}: GetReportDataPointsOptions) => {
  if (!data) {
    return [];
  }

  const aggregatesResponseView = data;

  if (
    !aggregatesResponseView ||
    aggregatesResponseView.__typename !== 'GetAggregatesResponse'
  ) {
    return [];
  }

  return sortReportDataPoints({
    records: getReportDataPointFromAggregatesResponse({
      aggregatesResponseView,
      shouldRemoveFileUploadPrefix,
    }),
    sortBy: DEFAULT_SORT_BY,
  });
};
